import React from 'react'
import { Route, Switch } from 'react-router'
import ReportDriverAllowances from './ReportDriverAllowances'

const Allowances = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportDriverAllowances} />
    </Switch>
)

export default Allowances
